import { Dispatch, SetStateAction } from 'react';
import { TFunction } from 'react-i18next';

import { Address } from '../../../types/address';
import { LabelValue } from '../../../types/options';
import { noColumnStyle } from '../../../utils/constants/tables';
import ActionsTableMenu from '../Components/ActionsTableMenu/ActionsTableMenu';

export type LogisticsRoute = {
  id: number;
  name: string | null;
  transporters: { id: number; name: string }[];
  points: {
    address: Address;
    entityId: number;
    maintenanceTimeframe: string;
    pointName: string;
    pointType: string;
    routePointId: number;
    pointTypeId: number;
    sequence: number;
  }[];
};

export const tableStorageKey = 'logistics_routes_dataTable';

export function getColumnHeadersMap(t: TFunction) {
  return {
    no: t('No.'),
    name: t('Name'),
    departureTime: t('Departure Time'),
  };
}

export function getPrivacyOptions(t: TFunction): LabelValue[] {
  return [
    { label: t('Public'), value: 'public' },
    { label: t('Private'), value: 'private' },
    { label: t('Protected'), value: 'protected' },
  ];
}

export function getPointTypes(t: TFunction) {
  return [
    { value: 1, label: t('Warehouse') },
    { value: 2, label: t('Drop point') },
    { value: 3, label: t('Locker') },
  ];
}

export function additionalColumnProperties(
  t: TFunction,
  column: keyof ReturnType<typeof getColumnHeadersMap> | 'actions',
  setContextMenuSelection: Dispatch<SetStateAction<any>>,
  setAction: (t: string) => void,
  setCaller: Dispatch<SetStateAction<'context-menu' | 'group-actions'>>,
  readGuard: boolean,
  editGuard: boolean,
  deleteGuard: boolean
) {
  switch (column) {
    case 'no':
      return {
        noColumnStyle,
        style: {
          width: 30,
          maxWidth: 30,
        },
        bodyStyle: {
          width: 30,
          maxWidth: 30,
          display: 'flex',
          textAlign: 'center',
        },
      };

    case 'name':
    case 'departureTime':
      return {
        style: { width: 350 },
        bodyStyle: { width: 350 },
      };

    case 'actions':
      return {
        body: (row: LogisticsRoute) => {
          return (
            <ActionsTableMenu
              actions={[
                {
                  label: t('View Details'),
                  icon: 'fas fa-search',
                  disabled: !readGuard,
                  command: () => {
                    setContextMenuSelection(row);
                    setAction('view-details');
                    setCaller('context-menu');
                  },
                },
                {
                  label: t('Edit'),
                  icon: 'fas fa-edit',
                  disabled: !editGuard,
                  command: () => {
                    setContextMenuSelection(row);
                    setAction('edit');
                    setCaller('context-menu');
                  },
                },
                {
                  label: t('Delete'),
                  icon: 'fas fa-times',
                  disabled: !deleteGuard,
                  command: () => {
                    setContextMenuSelection(row);
                    setCaller('context-menu');
                    setAction('delete');
                  },
                },
              ]}
            />
          );
        },
        style: {
          width: 60,
          borderLeft: '1px solid #e9ecef',
          flex: '0 1 auto',
          position: 'sticky',
        },
        bodyStyle: {
          width: 60,
          borderLeft: '1px solid #e9ecef',
          flex: '0 1 auto',
          position: 'sticky',
          justifyContent: 'center',
        },
      };

    default:
      return {};
  }
}
